class VotingsTabsController {

  element = null

  constructor(aVotingsElement) {
    this.element = aVotingsElement

    delegate(this.element, '.votings-tabs label', 'click', (aEvent) => {
      const input = aEvent.delegateTarget.previousElementSibling,
            tab = input.getAttribute('data-tab'),
            votingBox = input.closest('[data-input=votings-box]')

      this._updateTabsVisibility(votingBox, tab)
    })
  }

  _updateTabsVisibility(aVotingBox, aTab) {
    const votingBoxContent = aVotingBox.querySelector('[data-input=votings-box-content]'),
          activeTab = votingBoxContent.querySelector('[data-active=true]'),
          tabToSelect = votingBoxContent.querySelector(`[data-tab-content=${aTab}]`),
          url = tabToSelect.getAttribute('data-url')

    activeTab.setAttribute('data-active', 'false')
    tabToSelect.setAttribute('data-active', 'true')

    this._loadContentFor(aVotingBox, tabToSelect, url)
  }

  _loadContentFor(aVotingBox, aTabContent, aUrl) {
    const loading = aTabContent.getAttribute('data-loading') === 'true',
          loaded = aTabContent.getAttribute('data-loaded') === 'true'

    if (! loading && ! loaded) {

      aTabContent.setAttribute('data-loading', 'true')

      Rails.ajax({
        url: aUrl,
        type: 'GET',
        data: null,

        success: function(data, status, xhr) {
          const contentResult = aTabContent.querySelector('[data-input=content-result]')

          contentResult.innerHTML = xhr.responseText
        },

        complete: function() {
          aTabContent.setAttribute('data-loading', 'false')
          aTabContent.setAttribute('data-loaded', 'true')
        }
      })


    }

  }
}

export { VotingsTabsController }
